import Vue from 'vue'
import VueRouter from 'vue-router'
import VueSession from 'vue-session'

Vue.use(VueSession)
Vue.use(VueRouter)


const routes = [
  {
    path: '/',
    name: 'Register',
    component: () => import('../views/Register.vue'),
    props: true
  },
  {
    path: '/viewdetail/:taxid',
    name: 'Viewdetail',
    component: () => import('../views/Viewdetail.vue'),
    props: true
  },
  {
    path: '/listregist',
    name: "ListRegist",
    component: () => import('../views/Listregist.vue'),
    props: true
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
